import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {AppearanceSettings} from './AppearanceSettingsDialog'

registerReactPartial('appearance-settings', {
  Component: AppearanceSettings,
})
